import type { OtherChannelCandidate } from '@/entities/outreach-candidate';
import { Button } from '@/shared/ui/atoms';
import * as s from './OtherChannelList.css';

export interface OtherChannelListProps {
  items: OtherChannelCandidate[];
  loading: boolean;
  failed: boolean;
  hasMore: boolean;
  onMore: () => void;
}

const numberFormat = new Intl.NumberFormat('ko-KR');

const profileUrl = (handle: string) =>
  `https://www.tiktok.com/@${encodeURIComponent(handle.replace(/^@/, ''))}`;

/**
 * 이메일이 없는 후보 — 다른 매체(틱톡 DM 등)로 따로 섭외할 사람을 같은 조회·같은 순서로 보인다.
 * 메일 대상에는 들지 않는다. 인스타그램·라인 주소는 이 조회에 없어 틱톡 프로필 링크까지만 건다.
 */
export function OtherChannelList({
  items,
  loading,
  failed,
  hasMore,
  onMore,
}: OtherChannelListProps) {
  return (
    <section className={s.root} aria-label="다른 매체로 섭외할 사람">
      <p className={s.note}>
        이메일 주소가 없는 후보입니다. 메일 대상에는 들지 않고 자동 발송되지 않으니, 인스타그램·틱톡
        DM 같은 다른 매체로 직접 섭외해 주세요.
      </p>
      {failed ? (
        <p className={s.error} role="alert">
          이메일 없는 후보를 불러오지 못했습니다.
        </p>
      ) : null}
      {items.length > 0 ? (
        <ul className={s.list}>
          {items.map((item) => (
            <li key={item.externalCreatorId} className={s.row}>
              <a href={profileUrl(item.handle)} target="_blank" rel="noreferrer">
                {item.handle}
              </a>
              <span className={s.meta}>
                {item.followers === null ? '' : `팔로워 ${numberFormat.format(item.followers)}`}
              </span>
            </li>
          ))}
        </ul>
      ) : loading ? (
        <p className={s.note}>이메일 없는 후보를 찾는 중입니다.</p>
      ) : !failed ? (
        <p className={s.note}>지금까지 훑은 범위에는 이메일이 없는 후보가 없습니다.</p>
      ) : null}
      {hasMore ? (
        <Button variant="ghost" size="xs" disabled={loading} onClick={onMore}>
          더 찾기
        </Button>
      ) : null}
    </section>
  );
}
